import i from './reefer-data.container';

export default i;
